import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <>
      <div className="relative">
        <div
          className="bg-cover bg-center text-center text-white p-8"
          style={{
            backgroundImage: `url("./images/innerb.jpg")`,
          }}
        >
          <div className="text-center pt-40 pb-28">
            <h1 className="text-2xl md:text-4xl font-bold">
              Conditions Générales d'Utilisation
            </h1>
            <p className="text-white/80 mt-2 text-sm md:text-base">
              SEVA Sàrl — Cabinet de santé et conseil
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-12 px-4 max-w-5xl">
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 md:p-12 text-[#546E7A] leading-relaxed space-y-8">
          {/* Preamble */}
          <div className="border-b border-gray-100 pb-6">
            <p className="text-sm text-gray-500 mb-4">
              Ce site web <span className="font-semibold text-[#037897]">centre-seva.com</span> ("Site Web") est détenu, géré et exploité par <strong>SEVA Sàrl</strong>, Cabinet de santé et conseil, Chemin des Coteaux 18, 1188 Saint-George, Suisse ("SEVA").
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Les présentes Conditions Générales d'utilisation ("Conditions Générales") définissent les règles d'utilisation du Site Web, des applications associées et/ou des Services décrits ci-dessous. Veuillez les lire attentivement avant d'utiliser le Site Web ou les applications associées.
            </p>
            <p className="text-sm text-gray-500">
              Toute référence aux mots <em>"Vous"</em> ou <em>"Votre"</em>, tels qu'ils sont utilisés dans le présent document, renvoie à la (aux) personne(s) qui accède(nt) au Site Web ou l'utilise(nt) à quelque fin que ce soit, et inclut tout employé ou agent de la (des) personne(s) qui accède(nt) au Site Web et l'utilise(nt) pour bénéficier des Services.
            </p>
          </div>

          {/* Section 1 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">1</span>
              Acceptation Contractuelle
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                En utilisant le Site Web, Vous déclarez avoir lu et accepté d'être lié par les présentes Conditions Générales, ainsi que par les règles, les politiques et toute autre condition supplémentaire mentionnée dans le présent document. Si Vous n'êtes pas d'accord avec une quelconque partie des présentes Conditions Générales, Vous ne pouvez pas accéder à ce Site Web ni l'utiliser de quelque manière que ce soit.
              </p>
              <p>
                Avec la <Link to="/privacy-policy" className="text-[#037897] font-medium hover:underline">Politique de Confidentialité</Link>, les présentes Conditions Générales représentent l'intégralité de l'accord entre Vous et SEVA en ce qui concerne l'utilisation du Site Web, les applications associées et/ou des Services et remplacent toutes les négociations, représentations ou accords, écrits ou oraux, portant sur le même objet.
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">2</span>
              Éligibilité
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                En utilisant le Site Web, les applications associées et/ou les Services, Vous déclarez et garantissez avoir le droit, l'autorité et la capacité de conclure et d'être régi par les Conditions Générales relatives aux Services offerts par SEVA et de respecter tous les termes et conditions énoncés dans le présent document. En particulier :
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li><strong>(i)</strong> Vous acceptez la responsabilité financière de toutes les transactions effectuées sous Votre nom ou sur Votre compte.</li>
                <li><strong>(ii)</strong> Vous êtes âgé de plus de 18 ans et avez la capacité juridique de conclure un contrat dans Votre juridiction.</li>
                <li><strong>(iii)</strong> Vous disposez de toutes les autorisations, permissions, approbations et droits légaux nécessaires pour fournir le contenu destiné à être utilisé par SEVA et stocké sur le Site Web.</li>
                <li><strong>(iv)</strong> Vous déclarez et garantissez à SEVA que Vous utiliserez le Site Web d'une manière conforme à toutes les règles et réglementations applicables.</li>
                <li><strong>(v)</strong> Vous ne devez pas avoir été désactivé en tant qu'utilisateur du Site Web pour violation de la loi ou des Conditions Générales.</li>
              </ul>
            </div>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">3</span>
              Description des Services
            </h2>
            <div className="pl-11 space-y-4 text-sm md:text-base">
              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  a. Enregistrement sur le Site Web
                </h3>
                <p>
                  Pour passer une commande pour les Services proposés sur le Site Web, et l'achat qui s'ensuit, Vous devez Vous inscrire et créer un compte d'utilisateur sur le Site Web ("Compte"). L'accès à Votre compte est sécurisé par Votre e-mail et Votre mot de passe.
                </p>
                <p className="mt-2">
                  Ces données d'identification constituent les informations de connexion liées au compte de l'utilisateur. Vous reconnaissez que Votre Compte doit être strictement personnel, accessible uniquement par Vous et que Vous êtes responsable du maintien de la confidentialité de Votre Compte et de Vos informations de connexion ; Vous êtes entièrement responsable de toutes les activités qui se produisent sur Votre Compte. Vous acceptez d'informer immédiatement SEVA de toute utilisation non autorisée ou de toute suspicion d'utilisation non autorisée de Votre Compte.
                </p>
                <p className="mt-2">
                  Vous garantissez que toutes les informations que Vous fournissez sur Vous-même sont vraies et exactes. À l'issue de l'inscription, Vous aurez le droit de bénéficier des Services offerts par SEVA, moyennant le paiement du montant requis.
                </p>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  b. Services
                </h3>
                <p>
                  Les services de SEVA ("Services") consistent en des programmes de santé, séances d'accompagnement, ateliers de bien-être, consultations individuelles (1:1), et autres services proposés sur le Site Web.
                </p>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  c. Qualité des Services
                </h3>
                <p>
                  SEVA fournit les Services de manière professionnelle, en faisant preuve d'un degré de soin, de compétence et de diligence commercialement raisonnable, conformément aux pratiques, procédures et lois applicables. SEVA déclare que son personnel dispose de toutes les autorisations requises pour exécuter les Services (licences, permis, accréditations et certifications nécessaires).
                </p>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  d. Résultats et Rapports
                </h3>
                <p>
                  Une fois les Services fournis, SEVA Vous communiquera les résultats et/ou les rapports conformément au format standard de SEVA. Tout rapport et/ou résultat fourni par SEVA est uniquement destiné à Vous (ou au(x) destinataire(s) désigné(s)). Aucun rapport ne peut être distribué ou reproduit sans autorisation expresse.
                </p>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  e. Délais de Livraison
                </h3>
                <p>
                  Les délais de livraison, calendriers d'exécution et autres délais de fourniture des Services sont précisés sur le Site Web. Tout retard dont Vous êtes responsable exempte SEVA de tout engagement ou responsabilité concernant les délais d'exécution.
                </p>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  f. Contenu et Matériel
                </h3>
                <p>
                  SEVA conservera des copies de tous les rapports et résultats stockés dans ses systèmes pendant 5 ans à compter de la date à laquelle les Services ont été rendus, ou pendant toute autre période requise par la loi applicable. SEVA a le droit d'utiliser à des fins scientifiques ou de développement des données anonymisées et agrégées qui ne permettent en aucun cas de Vous identifier.
                </p>
              </div>

              <div className="bg-[#EDF2F6] p-4 rounded-xl border border-gray-200">
                <h3 className="text-base md:text-lg font-semibold text-[#020220] mb-1">
                  g. Clause de Non-responsabilité Médicale
                </h3>
                <p className="text-xs md:text-sm">
                  Les informations fournies sur le Site Web, les résultats ou les rapports sont uniquement destinés à des fins d'information et <strong>ne constituent pas un substitut à des conseils ou à des recommandations médicales professionnelles</strong>. Si Vous avez des inquiétudes concernant Votre santé, Vous devez toujours consulter un médecin ou un professionnel de santé qualifié.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">4</span>
              Prix et Paiement
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                Tous les Prix pour les Services seront tels que définis sur le Site Web et payés par Vous à SEVA avant la prestation des Services. Vous autorisez SEVA à débiter Votre carte de crédit ou à traiter d'autres moyens de paiement sécurisés.
              </p>
              <p>
                Les services commandés et payés par l'intermédiaire du Site Web <em>ne sont pas automatiquement pris en charge par Votre assurance maladie</em> de base. Les reconnaissances RME et ASCA s'appliquent uniquement aux séances individuelles (1:1) selon les conditions de votre assurance complémentaire.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">5</span>
              Protection des Données
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                SEVA collecte et traite Vos données dans le cadre du processus d'enregistrement du Compte et de la fourniture des Services, dans le strict respect de la nouvelle loi suisse sur la protection des données (nLPD) et du RGPD. Veuillez consulter notre <Link to="/privacy-policy" className="text-[#037897] font-medium hover:underline">Politique de Confidentialité</Link> pour plus de détails.
              </p>
              <p>
                Pour révoquer Votre consentement marketing à tout moment, écrivez-nous à <a href="mailto:info@centre-seva.com" className="text-[#037897] hover:underline">info@centre-seva.com</a>.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">6</span>
              Propriété Intellectuelle
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                Le Site Web et son contenu (marques, logos, textes, visuels, vidéos, charte graphique, code et éléments interactifs) sont protégés par les lois relatives à la propriété intellectuelle et demeurent la propriété exclusive de SEVA Sàrl ou de ses concédants. Toute reproduction ou utilisation non autorisée est strictement interdite.
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">7</span>
              Limitation de Responsabilité
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                Dans la mesure autorisée par la loi applicable, la responsabilité de SEVA envers Vous pour toute réclamation découlant de l'utilisation du Site Web ou des Services est limitée à la réexécution du Service concerné ou au remboursement du montant payé pour ce Service.
              </p>
            </div>
          </section>

          {/* Section 8 & 9 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">8</span>
              Plaintes et Réclamations
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                Vous avez le droit de contacter SEVA pour déposer une réclamation concernant la qualité ou la facturation des Services dans un délai de 30 jours à compter de la découverte du problème par écrit ou par email à <a href="mailto:info@centre-seva.com" className="text-[#037897] hover:underline">info@centre-seva.com</a>.
              </p>
            </div>
          </section>

          {/* Section 10 & 11 */}
          <section className="space-y-3">
            <h2 className="text-xl md:text-2xl font-bold text-[#020220] flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-[#037897]/10 text-[#037897] flex items-center justify-center text-sm font-bold flex-shrink-0">9</span>
              Droit Applicable et Juridiction
            </h2>
            <div className="pl-11 space-y-3 text-sm md:text-base">
              <p>
                Les présentes Conditions Générales sont régies et interprétées conformément au <strong>droit suisse</strong>. Tout litige découlant des présentes Conditions Générales ou s'y rapportant sera soumis à la <strong>compétence exclusive des tribunaux de Lausanne, Suisse</strong>.
              </p>
              <div className="pt-4 border-t border-gray-100 flex flex-wrap items-center justify-between gap-4">
                <p className="text-xs text-gray-500">
                  Pour toute question concernant nos Conditions Générales : <a href="mailto:info@centre-seva.com" className="text-[#037897] font-semibold hover:underline">info@centre-seva.com</a>
                </p>
                <Link to="/contact" className="text-xs font-semibold text-[#037897] hover:underline uppercase tracking-wider">
                  Nous Contacter &rarr;
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
